import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { LolerReportsPage } from "./LolerReportsPage";
import { InsurerItemsPage } from "./InsurerItemsPage";

// Session BDF: ONE LOLER page with two tabs. "Reports" is one row per examiner report (the old LOLER
// reports page, unchanged); "To close" is the worklist of the items from those same reports (the old
// Insurance / Insurer items page, unchanged). The tab lives in the URL (?tab=to-close) so links and a
// refresh work. Each tab keeps its own filters in the URL, so switching tabs starts the other tab clean.

type LolerTab = "reports" | "to-close";

const TABS: { key: LolerTab; label: string }[] = [
  { key: "reports", label: "Reports" },
  { key: "to-close", label: "To close" },
];

export function LolerPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab: LolerTab = searchParams.get("tab") === "to-close" ? "to-close" : "reports";

  function choose(next: LolerTab) {
    if (next === tab) return;
    setSearchParams(next === "reports" ? {} : { tab: next });
  }

  return (
    <div>
      <div className="mb-3 flex flex-wrap gap-1" role="tablist" aria-label="LOLER">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => choose(t.key)}
            className={`max-sm:min-h-11 rounded-ele px-3 py-1.5 text-sm transition ${tab === t.key ? "bg-ele-purple text-ele-white" : "border border-ele-purple-accent text-ele-body hover:text-ele-strong"}`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "reports" ? <LolerReportsPage /> : <InsurerItemsPage />}
    </div>
  );
}

// The old /office/insurer-items address (and any sub-path) keeps working for bookmarks, the morning
// briefing and old links: it lands on the To close tab with its other filters (assetId, state...) intact.
export function InsurerItemsRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set("tab", "to-close");
  return <Navigate to={`/office/loler?${params.toString()}`} replace />;
}
